import React from "react";
import { Route, Routes } from "react-router-dom";
import Category from "../../views/assetmanagement/category/Category";
import Brand from "../../views/assetmanagement/brand/Brand";
import Product from "../../views/assetmanagement/product/Product";
import VendorList from "../../views/assetmanagement/vendor/Vendor";
import PurchaseView from "../../views/assetmanagement/purchase/PurchaseView";
import QuotationsView from "../../views/assetmanagement/quotations/QuotationsView";
import SaleView from "../../views/assetmanagement/sale/SaleView";
import Type from "../../views/assetmanagement/Type/Type";
import InventoryLanding from "../../views/assetmanagement/Inventory/InventoryLanding";
const AssetmanagementRouter = () => {
  return (
    <Routes>
      <Route path="category" element={<Category />} />
      <Route path="brand" element={<Brand />} />
      <Route path="product" element={<Product />} />
      <Route path="vendor" element={<VendorList />} />
      <Route path="quotations" element={<QuotationsView />} />
      <Route path="purchase" element={<PurchaseView />} />
      <Route path="sale" element={<SaleView />} />
      <Route path="inventory" element={<InventoryLanding />} />
      <Route path="type" element={<Type />} />
    </Routes>
  );
};

export default AssetmanagementRouter;
